var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000000",
      textTransform: "none",
      isolation: "auto",
      mixBlendMode: "normal"
    },
    d: "M 11,4 C 7.1456661,4 4,7.1456661 4,11 v 28 c 0,3.854334 3.1456661,7 7,7 h 28 c 3.854334,0 7,-3.145666 7,-7 V 11 C 46,7.1456661 42.854334,4 39,4 Z m 0,2 h 28 c 2.773666,0 5,2.2263339 5,5 v 28 c 0,2.773666 -2.226334,5 -5,5 H 11 C 8.2263339,44 6,41.773666 6,39 V 11 C 6,8.2263339 8.2263339,6 11,6 Z",
    fontWeight: 400,
    fontFamily: "sans-serif",
    "white-space": "normal",
    overflow: "visible",
    id: "path2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 3.4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 12.486608,25.183665 8.13734,8.13734 17.291847,-17.291848",
    id: "path835"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      strokeWidth: 0.238508,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    d: "M 10.147897,43.878942 C 8.256947,43.520669 6.811486,42.235069 6.2427852,40.405717 L 6.079227,39.879596 V 24.972831 10.066066 L 6.2703431,9.5048702 C 6.5431498,8.7037968 6.9134627,8.1104608 7.5178025,7.506121 8.1221422,6.9017813 8.7154783,6.5314683 9.5165516,6.2586616 L 10.077747,6.0675455 24.738989,6.0480588 c 16.47888,-0.021903 15.242151,-0.060235 16.414979,0.5087869 1.334589,0.647504 2.278207,1.8005478 2.680582,3.2755076 0.112571,0.4126467 0.122817,1.4570337 0.144406,14.7195807 0.01571,9.647743 -6.31e-4,14.483393 -0.05029,14.916974 -0.146918,1.281872 -0.55046,2.113497 -1.476931,3.043685 -0.477928,0.479845 -0.714614,0.656518 -1.192542,0.890165 -1.218502,0.595695 0.381019,0.540254 -16.029156,0.555588 -11.871064,0.01109 -14.682632,-0.0037 -15.082139,-0.0794 z m 19.78208,-17.362749 9.259459,-9.259658 -1.245046,-1.245046 -1.245046,-1.245046 -8.029184,8.028954 c -4.416052,4.415926 -8.044739,8.014513 -8.06375,7.996861 -0.01901,-0.01765 -1.58335,-1.578311 -3.476308,-3.46813 l -3.441741,-3.436035 -1.243889,1.243889 -1.243889,1.243889 4.699597,4.69999 c 2.584778,2.584995 4.715514,4.69999 4.734968,4.69999 0.01945,0 4.202127,-4.166846 9.294829,-9.259658 z",
    id: "path837"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChecked);
export default __webpack_public_path__ + "static/media/icon-checked.a1198fd3baa5337c48cdfc3457bd1037.svg";
export { ForwardRef as ReactComponent };